import React, { useRef, useState } from 'react';
import { Popover } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import styles from './CustomSelect.module.css';

interface CustomSelectProps {
  selectLabel: React.ReactNode;
  dropDownElement: (setOpened: React.Dispatch<React.SetStateAction<boolean>>, width?: number) => React.ReactNode;
  style?: React.CSSProperties;
  labelClassName?: string;
}

function CustomSelect({ selectLabel, dropDownElement, style, labelClassName }: CustomSelectProps) {
  const [opened, setOpened] = useState(false);
  const selectRef = useRef<HTMLButtonElement>(null);

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-end" offset={{ mainAxis: 6, crossAxis: 0 }}>
      <Popover.Target>
        <button
          ref={selectRef}
          style={style}
          type="button"
          onClick={() => setOpened((o) => !o)}
          className={`${styles.customSelectLabel} ${
            opened ? styles.customSelectLabelDropDownOpen : ''
          } ${labelClassName}`}
        >
          {selectLabel}
          <IconChevronDown
            color="var(--icon-subdued)"
            className={styles.dropdownArrow}
            style={{ transform: opened ? 'rotate(180deg)' : '' }}
            width={24}
            height={24}
          />
        </button>
      </Popover.Target>
      <Popover.Dropdown style={{ padding: 0, border: 0 }}>
        {dropDownElement(setOpened, selectRef?.current?.clientWidth)}
      </Popover.Dropdown>
    </Popover>
  );
}

export default CustomSelect;
